import { createFileRoute } from "@tanstack/react-router";
import { DashboardClean } from "@/components/dashboard/home/variant-clean/dashboard-clean";
import { workspaceAccessQuery } from "@/lib/team-api";
import { warmDashboard } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/")({
  // Starts every widget's request as the navigation begins; the widgets keep
  // their own skeletons, so nothing here is awaited.
  loader: ({ context }) => {
    const orgId = context.auth.session.session.activeOrganizationId ?? null;
    const access = context.queryClient.getQueryData(workspaceAccessQuery(orgId).queryKey);
    warmDashboard(context.queryClient, access?.permissions ?? null);
  },
  component: DashboardPage,
});

function DashboardPage() {
  return <DashboardClean />;
}
